import { useState } from 'react'

import scaleApproval from '../../demo/fixtures/scale-approval.json'
import { Card, CardHead, GlossaryText, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Toast, ToastHost } from '../../ui'
import { useW5Live, type LiveTriggerEntry } from '../analysis/live'
import { TriggerDetailDialog } from './TriggerDetailDialog'
import styles from './AutomationPage.module.css'
import logStyles from './TriggerLog.module.css'

export function TriggerLog() {
  const { automation } = useW5Live()
  const [entry, setEntry] = useState<LiveTriggerEntry | null>(null)
  const [toast, setToast] = useState<string | null>(null)
  return (
    <Card className={styles.section} data-scope="optimization-log" lang="zh-CN">
      <CardHead title={scaleApproval.copy.log.title} subtitle={scaleApproval.copy.log.subtitle} />
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>时间</TableHeader>
            <TableHeader>规则</TableHeader>
            <TableHeader>对象与动作</TableHeader>
            <TableHeader>结果</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {automation.triggerLog.map((logEntry) => {
            const state = automation.logState[logEntry.state] ?? { label: logEntry.state, tone: 'gray' }
            const label = state.label.replace('{t}', logEntry.undoneAt ?? '')
            return (
              <TableRow clickable key={logEntry.id} data-role="log-row" tabIndex={0} onClick={() => setEntry(logEntry)} onKeyDown={(event) => { if (event.key === 'Enter') setEntry(logEntry) }}>
                <TableCell numeric className={styles.logTime}>{logEntry.at}</TableCell>
                <TableCell><span className={styles.ruleChip}>{logEntry.rule}</span></TableCell>
                <TableCell className={styles.logAction}>
                  {logEntry.object}<br />
                  <span>{logEntry.what}</span>
                  {logEntry.hit ? <div className={logStyles.basis}><GlossaryText text={logEntry.hit} paren /></div> : null}
                </TableCell>
                <TableCell>
                  <span className={`${styles.statusChip} ${styles[`${state.tone}Chip`]}`}>{label}</span>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <TriggerDetailDialog entry={entry} onClose={() => setEntry(null)} onDone={setToast} />
      {toast ? <ToastHost><Toast onDismiss={() => setToast(null)}>{toast}</Toast></ToastHost> : null}
    </Card>
  )
}
